/* global require, __SKIN__*/
const skinConfig = require("../../skins/" + __SKIN__ + "/config.js");
const Config = require("./conf");
import Helpers from "../helpers/helperFunctions";

Config.env = Config.env || {};

Config.env.os = Helpers.getMobileOperatingSystem();

Helpers.mergeRecursive(Config, skinConfig);

try {
    console.log('trying to import rules 1')
    const Rules = require("../../skins/" + __SKIN__ + "/rules.js");
    console.log('trying to import rules 2')
    Helpers.mergeRecursive(Config, Rules);
} catch (error) {
    console.log('error')
}
export default Config;